import { BroadCastEditPage } from './broadCast.edit.page';

export default BroadCastEditPage;
